module.exports = "<div class=\"dropdown q-dropdown dropdown-parent-{%- index %} q-block-at-md overflow-dropdown\"> <a class=\"base-btn purple-btn v2-btn q-block-at-md\" href=# data-toggle=dropdown role=button aria-haspopup=true aria-expanded=true><span class=\"fa fa-chevron-down\"></span></a> <ul class=\"dropdown-menu overflow-dropdown-menu q-dropdown-left q-dropdown-no-max q-dropdown-full-at-mid\" data-parent-index=\"{%- index %}\"> {%= list %} </ul> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html
// module id = 26
// module chunks = 1